// extracted by mini-css-extract-plugin
export default {"segmented":"subtasks-tab_segmented__i6TDG","expandCards":"subtasks-tab_expandCards__deq5T"};